// extracted by mini-css-extract-plugin
export default {"content":"LuckyNumberPage_content__8g-04","numbers":"LuckyNumberPage_numbers__OwDeK"};